import { Http } from './http'

export const Api = () => {
    const host: string = window.location.host;

    const test = {
        "captchaId": "1a231dde2ec64e1aa69796068d6e259f",
        "env": "https://testplatform.smm.cn",
        "host": "https://testplatform.smm.cn",
        "news_host": "https://testnews.smm.cn",
        "votesite": "https://testvote-app.smm.cn",
        "link": "https://testmall.smm.cn",
        "link_m": "https://testm.smm.cn",
        "user_web": "https://testuser.smm.cn",
        "ga_tracking_id": ""
    }
    const platform = {
        "captchaId": "1a231dde2ec64e1aa69796068d6e259f",
        "env": "https://platform.smm.cn",
        "host": "https://platform.smm.cn",
        "news_host": "https://news.smm.cn",
        "votesite": "https://vote-app.smm.cn",
        "link": "https://mall.smm.cn",
        "link_m": "https://m.smm.cn",
        "user_web": "https://user.smm.cn",
        "ga_tracking_id": "UA-32613701-1"
    }
    if (host.indexOf("test") > -1 || host.indexOf("localhost") > -1 || host.indexOf(":8080") > -1) {
        return test
    }
    return platform
}

export const WXShareConfig = (title: string, desc: string, link: string, imgUrl: string) => {
    const location = window.location
    const url = `${Api().news_host}/api/wx/config?url=${encodeURIComponent(location.href.split('#')[0])}`
    Http.get(url).then(res => {
        if (res.code === 0) {
            const data = res.data
            wx.config({
                debug: false,
                appId: data.appId,
                timestamp: data.timestamp,
                nonceStr: data.nonceStr,
                signature: data.signature,
                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
            })
            wx.ready(() => {
                // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
                wx.updateAppMessageShareData({
                    title: title,
                    desc: desc,
                    link: link,
                    imgUrl: imgUrl
                })
                // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
                wx.updateTimelineShareData({
                    title: title,
                    link: link,
                    imgUrl: imgUrl
                })
            })
        }
    })
}


// WEBPACK FOOTER //
// ./src/utils/config.ts